import React from 'react'
import PropTypes from 'prop-types'
import ItemRow from '../../ItemRow'

const RelatedConnectorsRow = (props) => {
  const {
    name,
    id,
    description,
    harnessName,
    onConnectorSelect,
    selectedConnectors,
  } = props

  return (
    <ItemRow
      name={name}
      inputName={'related_connector_id'}
      value={id}
      onChange={() => onConnectorSelect(id)}
      isChecked={selectedConnectors?.includes(id)}
      description={description}
      isSelected={true}
    >
      {harnessName && (
        <div className="text-xs break-all">HS: {harnessName}</div>
      )}
    </ItemRow>
  )
}

RelatedConnectorsRow.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  id: PropTypes.number.isRequired,
  onConnectorSelect: PropTypes.func.isRequired,
  selectedConnectors: PropTypes.array.isRequired,
}

export default RelatedConnectorsRow
